import AnimatedSection from '@/components/ui/AnimatedSection';
import { BookOpen, Users, Globe, Award } from 'lucide-react';
import StatsCounter from '@/components/home/StatsCounter';

export default function About() {
    const values = [
        {
            icon: BookOpen,
            title: "Apprentissage Continu",
            description: "Nous croyons que l'éducation ne s'arrête jamais. Nos conférences couvrent des sujets variés allant de l'histoire à la science."
        },
        {
            icon: Users,
            title: "Convivialité",
            description: "L'UTA est avant tout un lieu de rencontre et d'échange. Nos événements sont l'occasion de tisser des liens sociaux forts."
        },
        {
            icon: Globe,
            title: "Curiosité",
            description: "Curiosité, découvrir d'anciennes et de nouvelles cultures à travers nos activités."
        },
        {
            icon: Award,
            title: "Excellence",
            description: "Nous sélectionnons des conférenciers de qualité, experts dans leur domaine, pour garantir un contenu riche et pertinent."
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50 pt-36 pb-20">
            {/* Hero Section */}
            <AnimatedSection className="container mx-auto px-6 mb-20 text-center">
                <h1 className="text-4xl md:text-6xl font-serif font-bold text-primary-900 mb-6">
                    À propos de l'<span className="text-accent-500">UTA</span>
                </h1>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    L'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe) est une association dédiée à la diffusion du savoir et à l'épanouissement culturel pour tous, sans condition d'âge ni de diplôme.
                </p>
            </AnimatedSection>

            {/* Image & Text Section */}
            <section className="bg-white py-20 mb-20">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                        <AnimatedSection delay={0.2} className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
                            <img
                                src="/images/about-conference.png"
                                alt="Conférence"
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-primary-900/20"></div>
                        </AnimatedSection>

                        <AnimatedSection delay={0.4}>
                            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
                                Notre Mission
                            </h2>
                            <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
                                <p>
                                    Fondée avec la conviction que la curiosité n'a pas d'âge, l'UTA Barvaux propose chaque année un programme riche et éclectique.
                                </p>
                                <p>
                                    Nous organisons 16 conférences par an, animées par des spécialistes passionnés. Ces rencontres sont complétées par des excursions culturelles en Belgique et à l'étranger, ainsi que des moments de convivialité comme notre traditionnel goûter.
                                </p>
                                <p>
                                    Notre objectif est double : stimuler l'intellect et favoriser le lien social dans notre région rurale.
                                </p>
                            </div>
                        </AnimatedSection>
                    </div>
                </div>
            </section>

            <section className="container mx-auto px-6 mb-20">
                <h2 className="text-3xl font-serif font-bold text-center text-gray-900 mb-12">Nos valeurs</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {values.map((value, index) => (
                        <AnimatedSection key={index} delay={index * 0.1} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                            <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mb-6 text-primary-600">
                                <value.icon size={24} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                            <p className="text-gray-600">
                                {value.description}
                            </p>
                        </AnimatedSection>
                    ))}
                </div>
            </section>

            {/* Stats Reuse */}
            <StatsCounter />

            {/* CTA */}
            <section className="container mx-auto px-6 mt-20 text-center">
                <div className="bg-primary-900 text-white rounded-3xl p-12 relative overflow-hidden">
                    <div className="relative z-10">
                        <h2 className="text-3xl font-serif font-bold mb-6">Envie de nous rejoindre ?</h2>
                        <p className="text-primary-100 mb-8 max-w-2xl mx-auto">
                            Devenez membre de l'UTA Barvaux et accédez à toutes nos activités. L'adhésion est ouverte à tous.
                        </p>
                        <a
                            href="/contact"
                            className="inline-block px-8 py-4 bg-accent-500 text-primary-950 font-bold rounded-lg hover:bg-accent-400 transition-colors"
                        >
                            Contactez-nous
                        </a>
                    </div>
                    {/* Background decoration */}
                    <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary-500/20 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
                </div>
            </section>
        </div>
    );
}
